
<f-dialog
    title   ="Datei Umbennen"
    v-model = "value"
    :width  = "460"
    @cancel = "onCancel"
    @store  = "onSave"
>
    <template v-slot:content>
        <v-text-field
            v-model        = "editname"
            autocomplete   = "off"
            autocorrect    = "off"
            autocapitalize = "off"
            spellcheck     = "false"
        />
    </template>
</f-dialog>
